export enum PriceCompareBidStatus {
  /**
   * 待委托方确认
   */
  WAIT_ENTRUST_CONFIRM = 0,

  /**
   * 待参与方确认
   */
  WAIT_PARTICIPANT_CONFIRM = 1,

  /**
   * 已成交
   */
  DEAL = 2,

  /**
   * 参与方已拒绝
   */
  PARTICIPANT_REFUSED = 3
}

/**
 * 参与方看到的状态文本
 */
export const PriceCompareBidStatusParticipantTextMap = {
  [PriceCompareBidStatus.WAIT_ENTRUST_CONFIRM]: '已出价',
  [PriceCompareBidStatus.WAIT_PARTICIPANT_CONFIRM]: '待确认',
  [PriceCompareBidStatus.DEAL]: '已成交',
  [PriceCompareBidStatus.PARTICIPANT_REFUSED]: '已拒绝'
}
/**
 * 委托方看到的状态文本
 */
export const PriceCompareBidStatusEntrustTextMap = {
  [PriceCompareBidStatus.WAIT_ENTRUST_CONFIRM]: '待确认',
  [PriceCompareBidStatus.WAIT_PARTICIPANT_CONFIRM]: '待参与方确认',
  [PriceCompareBidStatus.DEAL]: '已成交',
  [PriceCompareBidStatus.PARTICIPANT_REFUSED]: '参与方已拒绝'
}

/**
 * 平台方看到的状态文本
 */
export const PriceCompareBidStatusPlatformTextMap = {
  [PriceCompareBidStatus.WAIT_ENTRUST_CONFIRM]: '待委托方确认',
  [PriceCompareBidStatus.WAIT_PARTICIPANT_CONFIRM]: '待参与方确认',
  [PriceCompareBidStatus.DEAL]: '已成交',
  [PriceCompareBidStatus.PARTICIPANT_REFUSED]: '参与方已拒绝'
}

export const PriceCompareBidStatusColorMap = {
  [PriceCompareBidStatus.WAIT_ENTRUST_CONFIRM]: 'warning',
  [PriceCompareBidStatus.WAIT_PARTICIPANT_CONFIRM]: 'processing',
  [PriceCompareBidStatus.DEAL]: 'success',
  [PriceCompareBidStatus.PARTICIPANT_REFUSED]: 'error'
}
